import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface ISimplePayInvoiceInfoSetupFieldsPanel {
	isExporting: boolean,
	invoiceDDL: any;
	handleImportClick: (tag: string) => void
	exportDataPageName: string;
}

export const SimplePayInvoiceInfoSetupFieldsPanel: FC<
	ISimplePayInvoiceInfoSetupFieldsPanel
> = ({ invoiceDDL, isExporting, handleImportClick, exportDataPageName, }) => {

	return (
		<>
			<EnhancedDropDownRHFWithLabel
				selectName="invoiceId"
				label="Invoice No"
				labelPosition={LabelPosition.Top}
				testId={`invoice-no`}
				items={invoiceDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>
			<RHookFormDatePicker
				name="dueDate"
				testId="due-date"
				label="Due Date"
				labelPosition={LabelPosition.Top}
				format="M dd, yy"
				labelColumns={4}
				fieldColumns={8}
			/>

			{exportDataPageName === "quick_books" && <RHookFormTextFieldWithLabel
				label="G/L Reference"
				id="glReference"
				testId={`gl-reference`}
				labelPosition={LabelPosition.Top}
			/>}
			{exportDataPageName === "quick_books" && <EnhancedTextAreaFieldRHF
				label="Memo"
				id="memo"
				testId={`memo`}
				labelPosition={LabelPosition.Top}
			/>}

			<EnhancedButtonPrimeReact
				label={exportDataPageName === "quick_books" ? "Export to QuickBooks" : "Export"}
				// type="submit"
				raised
				severity={EnhancedButtonPrimeReactSeverity.Secondary}
				loading={isExporting}
				onClickHandler={() => handleImportClick("simplepay_invoice")}
			/>

		</>
	);
};
